import React from "react";

const AURA_VARIANTS = {
  home: {
    primary: "radial-gradient(circle, rgba(245,158,11,0.22) 0%, rgba(217,119,6,0.08) 42%, transparent 72%)",
    secondary: "radial-gradient(circle, rgba(250,204,21,0.12) 0%, rgba(245,158,11,0.04) 48%, transparent 74%)",
    tertiary: "radial-gradient(circle, rgba(222,149,47,0.14) 0%, rgba(91,53,14,0.04) 48%, transparent 72%)",
    accent: "linear-gradient(180deg, rgba(245,158,11,0.1) 0%, rgba(0,0,0,0) 68%)",
  },
  chat: {
    primary: "radial-gradient(circle, rgba(234,171,73,0.2) 0%, rgba(126,82,28,0.08) 42%, transparent 72%)",
    secondary: "radial-gradient(circle, rgba(208,161,78,0.14) 0%, rgba(95,65,28,0.05) 50%, transparent 74%)",
    tertiary: "radial-gradient(circle, rgba(82,129,157,0.12) 0%, rgba(37,66,80,0.04) 48%, transparent 70%)",
    accent: "linear-gradient(180deg, rgba(186,129,47,0.1) 0%, rgba(0,0,0,0) 68%)",
  },
  insights: {
    primary: "radial-gradient(circle, rgba(242,177,76,0.2) 0%, rgba(133,86,29,0.08) 44%, transparent 74%)",
    secondary: "radial-gradient(circle, rgba(219,176,98,0.12) 0%, rgba(102,68,30,0.04) 48%, transparent 74%)",
    tertiary: "radial-gradient(circle, rgba(250,226,173,0.08) 0%, rgba(132,95,37,0.03) 44%, transparent 72%)",
    accent: "linear-gradient(180deg, rgba(188,132,52,0.1) 0%, rgba(0,0,0,0) 68%)",
  },
  profile: {
    primary: "radial-gradient(circle, rgba(224,173,101,0.18) 0%, rgba(149,96,50,0.08) 42%, transparent 72%)",
    secondary: "radial-gradient(circle, rgba(190,135,86,0.12) 0%, rgba(102,63,44,0.04) 48%, transparent 74%)",
    tertiary: "radial-gradient(circle, rgba(246,228,199,0.08) 0%, rgba(131,92,59,0.03) 44%, transparent 72%)",
    accent: "linear-gradient(180deg, rgba(214,161,111,0.09) 0%, rgba(0,0,0,0) 68%)",
  },
};

export const PageBreathingAura = ({ variant = "home" }) => {
  const palette = AURA_VARIANTS[variant] || AURA_VARIANTS.home;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ zIndex: 0 }}
    >
      <div
        className="absolute -top-24 left-1/2 h-[21rem] w-[21rem] -translate-x-1/2 rounded-full"
        style={{
          background: palette.primary,
          animation: "backgroundBloom 13s ease-in-out infinite",
          filter: "blur(10px)",
        }}
      />
      <div
        className="absolute bottom-[18%] -right-16 h-[16rem] w-[16rem] rounded-full"
        style={{
          background: palette.secondary,
          animation: "orbitalDrift 14s ease-in-out infinite",
          filter: "blur(10px)",
        }}
      />
      <div
        className="absolute -left-14 bottom-[16%] h-[14rem] w-[14rem] rounded-full"
        style={{
          background: palette.tertiary,
          animation: "ambientLift 16s ease-in-out infinite",
          filter: "blur(12px)",
        }}
      />
      <div
        className="absolute inset-x-0 top-0 h-56"
        style={{
          background: palette.accent,
          animation: "slowPan 18s ease-in-out infinite alternate",
        }}
      />
    </div>
  );
};

export default PageBreathingAura;
